// src/screenGuard.js
import { ref } from 'vue';

const showPopup = ref(false);

// Routes that should be blocked below a given viewport width, replacing the
// per-page white "ScreenCover" slide-out with this single popup. A minWidth
// of 0 disables the guard for that route (kept for parity with pages that
// previously mounted ScreenCover with widthThreshold={0}, which never fired).
const screenGuardedRoutes = {
  schedule: 1000,
  OrgSettings: 400,
  timesheets: 1024,
  'export-timesheets': 1024,
  submitted: 1024,
  people: 0,
  locations: 0,
};

export const useScreenGuard = () => {
  const screenGuard = (to, from, next) => {
    const minWidth = screenGuardedRoutes[to.name];
    if (minWidth && window.innerWidth < minWidth) {
      showPopup.value = true;
      // On in-app navigation, abort and keep the user on their current page.
      // On a direct load / refresh of /schedule there is no previous route to
      // stay on (from === START_LOCATION), so redirect to the dashboard instead
      // of aborting into a blank screen.
      if (from.matched.length) {
        next(false); // Prevent navigation
      } else {
        next({ name: 'dashboard' });
      }
    } else {
      next(); // Allow navigation
    }
  };

  const closePopup = () => {
    showPopup.value = false;
  };

  return {
    showPopup,
    screenGuard,
    closePopup
  };
};
